import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {PutFileCB} from "../../ope/storage/PutFileCB";
import {DelFilesCB} from "../../ope/storage/DelFilesCB";

@Injectable({
  providedIn: 'root'
})
export class StorageOpeService extends BaseOPEService {

  public putFile(cb: PutFileCB) {
    return this.execMultipartOPE(cb);
  }

  public delFiles(cb: DelFilesCB) {
    return this.execOPE(cb);
  }

}
